import React from 'react'
import { Link } from "react-router-dom";
import HomeAbout from '../home/HomeAbout';
import MissionVision from '../home/MissionVision';
import HomeWorkingProcess from '../home/HomeWorkingProcess';
import HomeTestimonials from '../home/HomeTestimonials';
import OurFacilites from '../home/OurFacilites';
import PressRelease from '../home/PressRelease';
import HomeFaq from '../home/HomeFaq';


const About = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>हमारे बारे में</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                                <li className="breadcrumb-item">हमारे बारे में
होम हमारे बारे में</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>
            <PressRelease />
            <HomeAbout />
            <HomeFaq />
            <HomeTestimonials />
            <MissionVision />
            <OurFacilites />



        </>
    )
}

export default About